export default function visitWindow() {
	// noop
}
